import request from './request.js';
import {requestbody} from './request.js'
//权限相关
export async function importExcel (params = {

}) {
	return await request('balance/importExcel', 'post', params)
}
export async function mappingrulepage (params = {

}) {
	return await request('mappingEx/rule/page', 'post', params)
}
export async function companysPage (params = {

}) {
	return await request('mapping-rulefunc/companysPage', 'post', params)
}
export async function saveMappingRule (params = {

}) {
	return await requestbody('mapping-rulefunc/saveMappingRule', 'post', params)
}
export async function delMappingRule (params = {

}) {
	return await requestbody('mapping-rulefunc/delMappingRule', 'post', params)
}
//根据映射规则编码或id分页得到Mapping集合
export async function getMappingPageListByRule (params = {

}) {
	return await request('mapping-rulefunc/getMappingPageListByRule', 'post', params)
}
//根据id获取详情
export async function mappingrulefuncgetById (params = {

}) {
	return await requestbody('mapping-rulefunc/getById', 'post', params)
}
//修改科目映射规则
export async function updateMappingRule (params = {

}) {
	return await requestbody('mapping-rulefunc/updateMappingRule', 'post', params)
}
//获取列表
export async function getTempBlanceDataPage (params = {

}) {
	return await request('mapping/getTempBlanceDataPage', 'post', params)
}
//
export async function queryCompanySz (params = {

}) {
	return await request('sys/queryCompanySz', 'post', params)
}
//获取科目详情
export async function getDetailById (params = {

}) {
	return await requestbody('mapping/getDetailById', 'post', params)
}
//新增科目信息
export async function saveMapping(params = {

}) {
	return await requestbody('mapping/saveMapping', 'post', params)
}
//编辑科目信息
export async function updateMapping(params = {

}) {
	return await requestbody('mapping/updateMapping', 'post', params)
}
//映射关系导入
export async function importMapping(params = {

}) {
	return await request('mapping/importMapping', 'post', params)
}
//清除映射
export async function clearMapping(params = {

}) {
	return await requestbody('mapping/clearMapping', 'post', params)
}
//根据导入批次号得到导入模板中公司集合信息
export async function getSubjectCompanys(params = {

}) {
	return await requestbody('mapping/getSubjectCompanys', 'post', params)
}
//上传科目映射保存提交
export async function checkMapping(params = {

}) {
	return await requestbody('mapping/checkMapping', 'post', params)
}
//科目余额分页查询
export async function balancePage(params = {

}) {
	return await request('balance/page', 'post', params)
}
//上传历史记录分页查询
export async function uploadhistorypage(params = {

}) {
	return await request('input-history/page', 'post', params)
}
//下载原文件
export async function downloadOriginalFile(params = {

}) {
	return await requestbody('upload-history/downloadOriginalFile', 'post', params)
}

//下载原文件
export async function uploadhistorydelete(params = {

}) {
	return await requestbody('upload-history/deleteBatch', 'post', params)
}
//模板信息分页查询
export async function templateInfopage(params = {

}) {
	return await request('template-info/page', 'post', params)
}
//删除模板
export async function deleteTemplate(params = {

}) {
	return await requestbody('template-info/deleteTemplate', 'post', params)
}
//获取模板
export async function getTemplate(params = {

}) {
	return await requestbody('template-info/getTemplate', 'post', params)
}
//获取文件表头
export async function getFileColumn(params = {

}) {
	return await request('template-info/getFileColumn', 'post', params)
}
//添加自定义模板
export async function templateInfoSave(params = {

}) {
	return await requestbody('template-info/save', 'post', params)
}
//根据id获取模板详情
export async function getTemplateById(params = {

}) {
	return await requestbody('template-info/getTemplateById', 'post', params)
}
//根据id获取模板详情
export async function templateinfoupdate(params = {

}) {
	return await requestbody('template-info/update', 'post', params)
}


export async function getUserInfo(params = {

}) {
	return await request('getUserInfo', 'GET', params)
}
export async function checkoutUserPeriod(params = {

}) {
	return await request('sys/checkoutUserPeriod', 'post', params)
}

export async function moduleInfo(params = {

}) {
	return await requestbody('home/moduleInfo', 'post', params)
}
export async function getReportAdditionalInfo(params = {

}) {
	return await request('manuscript/getReportAdditionalInfo', 'post', params)
}
//获取进行增值税的模板
// export async function iinv_templateIinvUpload(params = {

// }) {
// 	return await requestbody('IINV/uploadInvTemplate', 'post', params)
// }

//复制规则
export async function copyMappingRule (params = {

}) {
	return await requestbody('mapping-rulefunc/copyMappingRule', 'post', params)
}

// 查询当前用户下所有的公司信息
export async function queryCompanyList(params = {}) {
	return await request('/sys/queryCompanyList', 'post', params)
}

